import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { useListIrosQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Iro',
  props: {
    iroIds: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(__props) {
    var search = ref('');
    var offset = ref(0);
    var limit = ref(100);
    var variables = computed(function () {
      return {
        input: {
          search: search.value
        },
        offset: offset.value,
        limit: limit.value
      };
    });
    var _useListIrosQuery = useListIrosQuery(variables),
      iroResult = _useListIrosQuery.result,
      iroLoading = _useListIrosQuery.loading,
      refetch = _useListIrosQuery.refetch;
    var iroItems = computed(function () {
      var _iroResult$value;
      return ((_iroResult$value = iroResult.value) === null || _iroResult$value === void 0 ? void 0 : _iroResult$value.listIros.map(function (iro) {
        return {
          text: iro.name,
          value: iro.id
        };
      })) || [];
    });
    function onScroll(event) {
      var bottom = event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight;
      if (bottom && !iroLoading.value) {
        offset.value += limit.value;
        refetch(variables.value);
      }
    }
    return {
      __sfc: true,
      search: search,
      offset: offset,
      limit: limit,
      variables: variables,
      iroResult: iroResult,
      iroLoading: iroLoading,
      refetch: refetch,
      iroItems: iroItems,
      onScroll: onScroll
    };
  }
});